<sub-nav [menu]="menu"></sub-nav>
<router-outlet></router-outlet>
